<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line>
        <v-list-item-title class="headline">{{
          $t('administration.rgpd.donneesRGPD.title')
        }}</v-list-item-title>
        <v-list-item-subtitle>{{
          $t('administration.rgpd.donneesRGPD.subtitle')
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text class="pt-0">
      <v-row>
        <v-col cols="12" sm="4">
          <search-by
            :datasource="datasourcePP"
            attr="nom"
            @storeSearch="storeSearch('contact', 'nom', $event)"
            i18n="recherche.rechercheSimple.personnePhysique.search.nom"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <search-by
            :datasource="datasourcePP"
            attr="prenom"
            @storeSearch="storeSearch('contact', 'prenoms', $event)"
            i18n="recherche.rechercheSimple.personnePhysique.search.prenoms"
          />
        </v-col>
      </v-row>

      <datasource-table
        v-model="selectedPP"
        :datasource="datasourcePP"
        @item-selected="selectedItemTraitements"
        :callRefresh="callRefresh"
        :tableProps="{ showSelect: true, singleSelect: true }"
        ref="datasourceRef"
      >
        <template #item.nom="{item}">
          <navigable-link :to="$liens().personnePhysique(item.id)">
            {{ item.nom }}
          </navigable-link>
        </template>
        <template #item.prenoms="{item}">
          <navigable-link :to="$liens().personnePhysique(item.id)">
            {{ item.prenoms }}
          </navigable-link>
        </template>
        <template #item.contacts="{item}">
          <v-row v-for="contact in item.contacts" :key="contact">
            {{ contact }}
          </v-row>
        </template>
      </datasource-table>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="exporterRGPD"
          color="primary"
          :disabled="exportDisabled"
        >
          {{ $t('administration.rgpd.donneesRGPD.exporter') }}
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';
import { getInternational } from '@/components/telephone/telephoneUtil.js';
import { saveAs } from 'file-saver';
import toasted from '@/utils/toasted';
import arraybufferToResponse from '@/utils/errors';

export default {
  props: {
    fieldName: {
      type: Array,
      default() {
        return ['_select-one'];
      },
    },
    callRefresh: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.datasourcePP.refresh();
    this.$store.commit('origine/recherche', {
      recherche: 'recherchesimple',
    });
  },
  data() {
    const datasourcePP = new Datasource('rgpd/personne-physique', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['nom'],
      descending: [false],
      labelNamespace: 'recherche.rechercheSimple.personnePhysique.list',
      args: {},
      fields: [
        {
          value: 'nom',
          sortable: true,
        },
        {
          value: 'prenoms',
          sortable: true,
        },
        {
          value: 'contacts',
          sortable: false,
        },
      ],
    });

    const initialSearch = this.$store.state.search.oldSearchField;
    datasourcePP.page = initialSearch.contact.page;
    Object.entries(initialSearch.contact.args).forEach(element => {
      datasourcePP.args[element[0]] = element[1];
    });

    return {
      datasourcePP,
      selectedPP: null,
    };
  },
  methods: {
    getInternational,
    storeSearch(entity, fieldName, value) {
      this.$store.commit('search/updateSearchField', {
        entity: entity,
        field: fieldName,
        value: value,
      });
    },
    selectedItemTraitements(item) {
      this.$emit('item-selected', item);
    },
    changeCallRefreshValue(val) {
      this.$refs.datasourceRef.changeCallRefreshValue(val);
      this.$refs.datasourceRef.datasourceRefresh();
    },
    exporterRGPD() {
      var pagination = null;
      const id = this.selectedPP.flatMap(p => p.id);
      var params = {
        ids: id,
        criteres: [
          'civilite',
          'nom',
          'prenoms',
          'identifiant',
          'accesAgil',
          'acces',
          'personneMorale',
          'division',
          'titre',
          'typeContact',
          'moyenContactPrefere',
          'fonctionContact',
          'remplacant',
          'telephone',
          'fax',
          'mail',
          'adresse',
          'dateLimiteValidite',
          'instanceParticipant',
        ],
        format: 'excel',
        taille: 'A3',
      };
      const uri = 'rgpd/export/personne-physique';

      return this.$api(uri)
        .post(params, { params: pagination, responseType: 'arraybuffer' })
        .then(
          response => {
            this.erreurExport = '';
            const contentType = response.headers.get('content-type');
            const contentDisposition = response.headers.get(
              'content-disposition',
            );
            if (
              contentDisposition &&
              contentDisposition.indexOf('attachment') !== -1
            ) {
              const regex = /filename="([^"]+)"/;
              let match = contentDisposition.match(regex);
              if (match) {
                let blob = new Blob([response.data], { type: contentType });
                saveAs(blob, match[1]);
              } else {
                toasted.error('recherche.export.error.noFilename');
              }
            } else {
              toasted.error('recherche.export.error.noAttachment');
            }
          },
          response => {
            var jsonResponse = arraybufferToResponse(response);
            if (jsonResponse && jsonResponse.status) {
              toasted.error(
                this.$t('recherche.export.error.serverErrorWithStatus', {
                  status: jsonResponse.status,
                }),
              );
            } else {
              toasted.error(this.$t('recherche.export.error.serverError'));
            }
          },
        )
        .finally(() => {
          this.waitForExport = false;
        });
    },
  },
  computed: {
    exportDisabled() {
      return this.selectedPP === null || this.selectedPP.length === 0;
    },
  },
};
</script>
